<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <FilterButtons
          :filters="appliedFilters"
          @filter-removed="removeFilter"
        />

        <CollectionFilters
          :filters="filters"
          :active-filters="appliedFilters"
          @filters-submitted="submitFilters"
          @filters-cleared="clearFilters"
        />
      </v-flex>
      <v-flex
        xs12
      >
        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <DiscountsDataTableRow
              :props="props" />
          </template>

          <template slot="no-data">
            <v-btn
              color="primary"
              @click="clearFilters"
            >
              {{ $t('Reset') }}
            </v-btn>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DiscountsDataTableRow from '../components/DiscountsDataTableRow'
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'
import CollectionFilters from '../../../vuetify-console/components/CollectionFilters'
import FilterButtons from '../../../vuetify-console/components/FilterButtons'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('campaigns/discounts')

export default {
  name: 'Discounts',
  components: {
    DiscountsDataTableRow,
    MassActionSelect,
    CollectionFilters,
    FilterButtons
  },

  actionBar () {
    return {
      title: 'Discounts',
      actions: [
        {
          text: 'Add Discount',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: [],
      search: '',
      rightDrawer: false
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Type'), value: 'type' },
        { text: this.$t('Status'), value: 'active', sortable: false },
        { text: this.$t('Code'), value: 'code' },
        { text: this.$t('Start Date'), value: 'start_date' },
        { text: this.$t('End Date'), value: 'end_date' }
      ]
    },

    filters () {
      return [
        { field: 'name', type: 'string', label: this.$t('Name') },
        { field: 'type', type: 'string', label: this.$t('Type') },
        { field: 'code', type: 'string', label: this.$t('Code') },
        { field: 'start_date', type: 'date', label: this.$t('Start Date') },
        { field: 'end_date', type: 'date', label: this.$t('End Date') }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    onActionAdd () {
      this.$router.push({ name: 'single-discount', params: { id: '__' } })
    },

    submitFilters (filters) {
      this.applyMeta({ filters })
    }
  }
}
</script>
